/* ==========================================================================
   Selvo — Premium Navbar Scroll Enhancement
   ========================================================================== */
(function () {
  const navbar = document.getElementById('navbar-wrapper');
  if (!navbar) return;
  function updateNavbar() {
    if (window.scrollY > 60) {
      navbar.classList.add('is-scrolled');
    } else {
      navbar.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', updateNavbar, { passive: true });
  updateNavbar();
})();

/* ==========================================================================
   Selvo — Scroll Reveal Animation
   Watches .selvo-reveal elements and adds .is-visible when in viewport
   ========================================================================== */
(function () {
  function initReveal() {
    const items = document.querySelectorAll('.selvo-reveal');
    if (!items.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

/* ==========================================================================
   DINAYA — Premium Product Card & Variant Size Selection Integration
   Safe integration with theme cart-container and Shopify Ajax Cart API
   ========================================================================== */
(function () {
  function initProductCardInteractions() {
    // 1. Variant Drawer Trigger: Toggle open/close of in-card size drawer
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.js-variant-drawer-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const card = trigger.closest('.product-card');
        const drawer = card ? card.querySelector('.product-card__variant-drawer') : null;
        if (!drawer) return;

        const isOpen = drawer.classList.contains('is-open');

        // Close any other open variant drawers on the page for clean UX
        document.querySelectorAll('.product-card__variant-drawer.is-open').forEach(function (d) {
          if (d !== drawer) {
            d.classList.remove('is-open');
            const otherTrigger = d.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          drawer.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          drawer.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Close button inside variant drawer
      const closeBtn = e.target.closest('.js-variant-drawer-close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const drawer = closeBtn.closest('.product-card__variant-drawer');
        if (drawer) {
          drawer.classList.remove('is-open');
          const trigger = drawer.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      // Dismiss drawer when clicking anywhere outside of the product card
      if (!e.target.closest('.product-card__variant-drawer') && !e.target.closest('.js-variant-drawer-trigger')) {
        document.querySelectorAll('.product-card__variant-drawer.is-open').forEach(function (drawer) {
          drawer.classList.remove('is-open');
          const trigger = drawer.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // 2. Desktop cursor leave: close drawer when cursor moves outside the product card
    document.addEventListener('mouseover', function (e) {
      if (!window.matchMedia('(hover: hover)').matches) return;
      const openDrawer = document.querySelector('.product-card__variant-drawer.is-open');
      if (openDrawer && !e.target.closest('.product-card')) {
        openDrawer.classList.remove('is-open');
        const trigger = openDrawer.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // 3. Add to Cart Handler (Delegated for initial & dynamically rendered cards)
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.js-add-to-cart');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('DINAYA Product Card: Missing data-variant-id on button', btn);
        return;
      }

      // Prevent duplicate submissions while a request is in progress
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      const originalText = btn.getAttribute('data-original-text') || btn.innerText.trim();
      if (!btn.getAttribute('data-original-text')) {
        btn.setAttribute('data-original-text', originalText);
      }

      btn.innerText = 'Adding...';
      btn.disabled = true;
      btn.classList.add('is-loading');

      const cartContainer = document.querySelector('cart-container');

      if (cartContainer && typeof cartContainer.add === 'function') {
        cartContainer.add({ items: [{ id: Number(variantId), quantity: 1 }] })
          .then(function () {
            btn.innerText = '✓ Added';
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');

            setTimeout(function () {
              btn.innerText = originalText;
              btn.disabled = false;
              btn.classList.remove('is-success');

              const drawer = btn.closest('.product-card__variant-drawer');
              if (drawer) {
                drawer.classList.remove('is-open');
                const trigger = drawer.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
                if (trigger) trigger.setAttribute('aria-expanded', 'false');
              }
            }, 1200);
          })
          .catch(function (error) {
            console.error('Error adding to cart:', error);
            btn.innerText = 'Error';
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');

            setTimeout(function () {
              btn.innerText = originalText;
              btn.disabled = false;
              btn.classList.remove('is-error');
            }, 1500);
          });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
        .then(async function (response) {
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Error adding to cart');
          }
          return data;
        })
        .then(function (data) {
          btn.innerText = '✓ Added';
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');

          window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          const offcanvasEl = document.querySelector('#offcanvas-cart');
          if (offcanvasEl && window.bootstrap && typeof window.bootstrap.Offcanvas === 'function') {
            window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).show();
          }

          setTimeout(function () {
            btn.innerText = originalText;
            btn.disabled = false;
            btn.classList.remove('is-success');

            const drawer = btn.closest('.product-card__variant-drawer');
            if (drawer) {
              drawer.classList.remove('is-open');
              const trigger = drawer.closest('.product-card')?.querySelector('.js-variant-drawer-trigger');
              if (trigger) trigger.setAttribute('aria-expanded', 'false');
            }
          }, 1200);
        })
        .catch(function (error) {
          console.error('Error:', error);
          btn.innerText = 'Error';
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');

          setTimeout(function () {
            btn.innerText = originalText;
            btn.disabled = false;
            btn.classList.remove('is-error');
          }, 1500);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardInteractions);
  } else {
    initProductCardInteractions();
  }
})();
